import {
  Divider,
  Box,
  Paper,
  Stack,
  Typography,
  useTheme,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Tooltip,
  Button,
} from "@mui/material";
import { Fragment, useEffect, useMemo, useState } from "react";

import { useOutletContext } from "react-router-dom";
import Alerts from "../../alerts";

import CardFeedBackPower from "./statusPotencia";
import { useMapa } from "../../../../contexts/mapaContext";
import {
  ExpandMore,
  ExpandMoreOutlined,
  Straight,
  Timeline,
} from "@mui/icons-material";

export default function CardPotencia(props, key) {
  const { elements, connectionsDataMap } = useMapa();
  const theme = useTheme();
  const [reference, setReference] = useState(null);
  const [destination, setDestination] = useState(null);
  const [colorAlert, setColorAlert] = useState("");
  const [pEntrada, setPEntrada] = useState("-");
  const [pSaida, setPSaida] = useState("-");
  const {
    conexao,
    index,
    expanded = false,
    setExpanded,
    unique = false,
    setFocusNodeId = () => {},
    setElementONUSelected = () => {},
    setOpenHistoryModal,
    setConnectionLocal,
  } = props;
  const connectionData = useMemo(
    () => connectionsDataMap.get(conexao.id),
    [connectionsDataMap, conexao.id],
  );

  const styles = {
    line: {
      position: "absolute",
      height: "80%", //typeElement == "Host" ? "150px" : "230px",
      minWidth: "3px",
      ml: "-5px",
    },
    acordion: {
      padding: "5px",
      borderRadius: "5px",
      backgroundColor: theme.palette.background.paperSelectedMaps,
      boxShadow: "0px 0px 3px  #0000001a",
      position: "relative",
      border: "none",
      "&::before": {
        display: "none",
      },
    },

    textMedium: {
      color: theme.palette.color.textDisabled,
      fontSize: "0.85rem",
    },

    textLarge: { fontSize: "2em" },
    contentTab: { gap: "10px" },
    detailsCard: {
      backgroundColor: theme.palette.background.paperLinkedMaps,
      paddingX: "10px",
      paddingY: "15px",
      display: "flex",
      flexDirection: "column",
      gap: 2,
    },
    text: {
      fontSize: "0.85em",
      width: unique ? "250px" : "200px",
      whiteSpace: "normal",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitLineClamp: 2, // Limite de 2 linhas
      WebkitBoxOrient: "vertical",
      textAlign: "left",
    },
    textAlerta: {
      fontSize: "0.85rem",

      color: theme.palette.color.textDisabled,
    },
    textHeaderAco: {
      fontSize: "0.9rem",
      color: theme.palette.color.text,
    },
  };
  function formatString(input) {
    return input
      .replace(/([A-Z])/g, " $1") // Adiciona um espaço antes de letras maiúsculas
      .replace(/^./, (str) => str.toUpperCase()) // Coloca a primeira letra em maiúscula
      .replace(/([a-z])([A-Z])/g, "$1 $2"); // Adiciona espaço entre letras minúsculas e maiúsculas
  }

  function handleChange(selected) {
    setExpanded(selected == expanded ? null : index);
    if (selected == expanded || selected == null) {
      setElementONUSelected(null);
    } else if (selected == index) {
      setElementONUSelected(conexao);
      setFocusNodeId(conexao.id);
    }
  }

  useEffect(() => {
    if (!connectionData) {
      setColorAlert(theme.palette.enlaces.offline.main);
      setPEntrada("-");
      setPSaida("-");
      return;
    }
    let status = connectionData?.status?.value || true;
    setColorAlert(connectionData?.corPower?.cor);
    if (connectionData?.rx_power != -40 && status) {
      setPEntrada(connectionData?.rx_power?.toFixed(2) ?? "-");
    } else setPEntrada(-40);
    if (connectionData?.tx_power != -40 && status)
      setPSaida(connectionData?.tx_power?.toFixed(2) ?? "-");
    else setPSaida(-40);
  }, [conexao.id, connectionData]);

  useEffect(() => {
    let reference = elements?.get(conexao.referenceId);
    let destination = elements?.get(conexao.destinationId);
    setReference(reference?.titulo);
    setDestination(destination?.titulo);
  }, [elements, conexao.id, connectionData]);

  return (
    <Accordion
      key={key}
      disableGutters
      expanded={expanded == index || unique}
      onChange={() => handleChange(index)}
      sx={styles.acordion}
    >
      <AccordionSummary
        expandIcon={!unique ? <ExpandMore /> : null}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
        sx={{
          padding: "0px",
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
          ml={1}
        >
          <Box>
            <Box sx={[styles.line, { backgroundColor: colorAlert }]}></Box>

            <Stack direction={"column"} gap={1} ml={1.5}>
              <>
                <Tooltip
                  title={
                    conexao?.referenceId === conexao?.id
                      ? reference
                      : destination
                  }
                >
                  <Typography sx={styles.text}>
                    {conexao?.referenceId === conexao?.id
                      ? reference
                      : destination}
                  </Typography>
                </Tooltip>
                <Divider width={"80px"} />

                <Tooltip
                  title={
                    conexao?.referenceId !== conexao?.id
                      ? reference
                      : destination
                  }
                >
                  <Typography sx={styles.text}>
                    {conexao?.referenceId !== conexao?.id
                      ? reference
                      : destination}
                  </Typography>
                </Tooltip>
              </>
            </Stack>
          </Box>
          <Straight
            sx={{
              fontSize: "30px",
              transform:
                conexao?.referenceId == conexao?.id ? "rotate(180deg)" : null,
              mr: 0,
              color: theme.palette.mode == "dark" ? "#565656" : "#9A9A9A",
            }}
          />
        </Stack>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          padding: "5px",
          display: "flex",
          gap: 1,
          flexDirection: "column",
        }}
      >
        {conexao?.coordinateIsValid == false && (
          <Alerts
            message="O equipamento não possui uma geolocalização cadastrada e não será exibida no mapa!"
            severity="warning"
          />
        )}

        <Paper sx={styles.detailsCard} elevation={0}>
          <Stack direction={"column"} gap={2}>
            <Typography textAlign={"center"} sx={styles.textAlerta}>
              {/* {"Potência" + (tipoEquipamento ? " da " + tipoEquipamento : "")} */}
              {"Potência da interface " + connectionData?.interface}
            </Typography>
            <Stack direction={"row"} justifyContent={"space-around"}>
              <Stack alignItems={"center"}>
                <Stack direction={"row"} sx={{ alignItems: "flex-end" }}>
                  <Typography sx={styles.textLarge}>{pEntrada}</Typography>
                  <Typography color="primary.main" mb={"6px"} ml={"2px"}>
                    dBm
                  </Typography>
                </Stack>
                <Typography sx={styles.textMedium}>Entrada (Rx)</Typography>
              </Stack>
              <Stack alignItems={"center"}>
                <Stack direction={"row"} sx={{ alignItems: "flex-end" }}>
                  <Typography sx={styles.textLarge}> {pSaida}</Typography>
                  <Typography color="primary.main" mb={"6px"} ml={"2px"}>
                    dBm
                  </Typography>
                </Stack>{" "}
                <Typography sx={styles.textMedium}> Saida (Tx)</Typography>
              </Stack>
            </Stack>
          </Stack>
          <Divider variant="middle" />

          <CardFeedBackPower connectionData={connectionData} />
        </Paper>
        {
          <Button
            variant="contained"
            sx={{
              backgroundColor:
                theme.palette.mode === "dark" ? "#464646" : "#d0d0d0ff",
              color: theme.palette.text.primary,
              textTransform: "capitalize",
              height: 48,
            }}
            disableElevation
            onClick={() => {
              setOpenHistoryModal(true);
              setConnectionLocal(conexao);
            }}
            startIcon={<Timeline />}
          >
            Ver histórico
          </Button>
        }
        {connectionData?.itensData?.length != 0 && (
          <Accordion
            key={key + "outrosItens"}
            disableGutters
            sx={{
              backgroundColor: theme.palette.background.paperLinkedMaps,
              boxShadow: "none",
              "&::before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreOutlined />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Typography sx={styles.textHeaderAco}>Outros itens</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {connectionData?.itensData?.map((item, index) => (
                <Fragment key={index + item.name}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent={"space-between"}
                    width="100%"
                  >
                    <Typography
                      sx={styles.textAlerta}
                      fontSize={"0.7rem"}
                      width="170px"
                    >
                      {item.name}
                    </Typography>

                    <Stack direction={"row"} gap={"2px"}>
                      <Typography textAlign={"end"}>
                        {item?.lastvalue}
                      </Typography>

                      <Typography color="primary" variant="small" mt={"5px"}>
                        {item?.units}
                      </Typography>
                    </Stack>
                  </Stack>
                  <Divider sx={{ mt: 1, mb: 1 }} />
                </Fragment>
              ))}
            </AccordionDetails>
          </Accordion>
        )}
      </AccordionDetails>
    </Accordion>
  );
}
